import { useState } from "react";
import {services} from "../Data/ServicesData"
import Pattern0 from "../images/PatternOne.webp";
import Pattern1 from "../images/PatternTwo.webp";
import Pattern2 from "../images/PatternThree.webp";
import Pattern3 from "../images/PatternFour.webp"  
const ServicesCard = () => {
const [bgImage, setBgImage] = useState("0");
const [zoom, setZoom] = useState(false);
  const [prevImage, setPrevImage] = useState(0);

const images = [
    Pattern0,
    Pattern1,
    Pattern2,
    Pattern3,
  ];  
  return (
        <div className={`bgContainer  ${zoom ? "zoomIn" : ""}`} style={{
        background: `linear-gradient(0deg, #000000 0%, rgb(236 0 0 / 23%) 67.82%),url(${images[bgImage]})`,
      }}
      >
         <div className="row  m-auto w-4/5">
             <ul className="CustomGrid">
                  {services.slice(0, 4).map((item,id)=>(
                    <li key={id} className={`GridColoum ColumCount-${id}` } onMouseEnter={() => {
                 setPrevImage(bgImage); // remember previous
                setBgImage(id);
                setZoom(true);
              }}
              onMouseLeave={() => {
               setBgImage(prevImage); // go back to previous image
                setZoom(false);
              }}>
                        <h4 className="font-bold text-white my-2">{item.title}</h4>
                        <p className="text-white">{item.description}</p>
                    </li>
                  ))}
             </ul>
         </div>
        </div>
    )
}
export default ServicesCard